module.exports = "/_next/static/images/avatar_Lenka-d88029dd2b29fec8bd712e6b731e027b.svg";